"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const color = require("color");
const themeColors = {
    primaryColor: color('#0057B8').mix(color('#000000'), 0.0),
    secondaryColor: color('#F3D03E').mix(color('#000000'), 0.0),
    warningColor: color('#FFCD4F'),
    dangerColor: color('#D22E0C'),
    successColor: color('#1FC696'),
    infoColor: color('#00acc1'),
    roseColor: color('#e91e63'),
    grayColor: color('#999999'),
    white: color('#ffffff'),
    black: color('#000000'),
    accessibilityWarningColor: color('#d82a00'),
    warningBackgroundColor: color('#ffd7e3'),
    warningTextColor: color('#0d1b23'),
    cornerColors: {
        activity: color('#0A548B'),
        activityContrast: color('#FFFFFF'),
        reward: color('#FECC36'),
        rewardContrast: color('#000000'),
        promotion: color('#FF4832'),
        promotionContrast: color('#000000'),
        game: color('#36B1E6'),
        gameContrast: color('#000000')
    },
    boxShadowColor: color('#1b75b9')
};
exports.default = {
    themeColors
};
//# sourceMappingURL=colors.js.map